import { configure } from "mobx"

configure({ enforceActions: 'never' })